import "./utils/polyfills"; //must go first
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { addNonTouchClass, listenUsingMouseClass } from "@spectrumselect/mi-ui-react";

import "@spectrumselect/mi-ui-react/build/styles/main.css";
import "./styles/mi-ui-react-override.scss"; // overrides to account for black background

addNonTouchClass()
listenUsingMouseClass()

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <BrowserRouter basename={"/focus_55ip_authe"}>
      <Provider store={store}>
        <App/>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);